import React, { useState } from "react";
import {
  Drawer,
  Button,
  Switch,
  Divider,
  DatePicker,
  TimePicker,
  notification,
} from "antd";
import { useTriggerCommandMutation } from "../../../services/segmentation.services";
import moment from "moment";
import { useSelector } from "react-redux";
import { convertToNigerianTime } from "../../../utils/timezones";
import { errorBlock } from "../../../controllers/errorBlock";
import { useScheduledConnectMutation } from "../../../services/commands.services";
import { useParams } from "react-router-dom";
const { RangePicker } = DatePicker;

const ScheduleConnection = ({
  type,
  open,
  setOpen,
  alias,
  setresult,
  setopenresult,
  intialCommand,
  setcommand,
}) => {
  const { siteid, timezone } = useSelector((state) => state.projectSite);
  const { username } = useSelector((state) => state.userDetails);
  const { name: domainname } = useSelector((state) => state.domain);
  const { meterid } = useParams();
  const [triggerCommand, { isLoading, error, isError, data }] =
    useTriggerCommandMutation();

  const [scheduledConnect, { isLoading: connectloading }] =
    useScheduledConnectMutation();

  const [daysofWeek, setDaysOfWeek] = useState([
    { id: 0, short: "sunday" },
    { id: 0, short: "monday" },
    { id: 0, short: "tuesday" },
    { id: 0, short: "wednesday" },
    { id: 0, short: "thursday" },
    { id: 0, short: "friday" },
    { id: 0, short: "saturday" },
  ]);

  const [timeRange, setTimeRange] = useState([]);
  const [frequency, setFrequency] = useState("weekly");

  const handleDayClick = (index) => {
    setDaysOfWeek((prev) =>
      prev.map((day, i) =>
        i === index ? { ...day, id: day.id === 0 ? 1 : 0 } : day
      )
    );
  };

  const handleTimeChange = (value) => {
    setTimeRange(value);
  };

  const handleFrequencyChange = (type) => {
    setFrequency(type);
  };

  const formatDate = (date) => {
    return timezone
      ? convertToNigerianTime(date, timezone, "YYYY-MM-DD")
      : date;
  };

  const handleSubmit = () => {
    const selectedDays = daysofWeek.map((day) => day.id).join("");
    if (type === "meter") {
      scheduledConnect({
        meterid: meterid,
        daybinaries: selectedDays,
        starttime: moment(timeRange[0]._d).format("HH:mm").replace(":", ""),
        endtime: moment(timeRange[1]._d).format("HH:mm").replace(":", ""),
        onetimeaction: frequency === "once" ? 0 : 1,
      }).then((res) => {
        if (res.error) {
          notification.error({
            message: "Failed",
            description: res.error.response,
          });
          //   console.log(res.error);
        } else {
          if (res.data?.response === "success") {
            notification.success({
              message: "Success",
              description: "Schedule connection command on meter sent",
            });
            setcommand(intialCommand);
            setOpen();
          }
        }
      });
    } else {
      if (timeRange.length == 0) {
        notification.error({
          message: "Error",
          description: "Please selected a time range",
        });
        return;
      }
      triggerCommand({
        alias,
        commandType: "CON",
        daybinaries: selectedDays,
        starttime: moment(timeRange[0]._d).format("HH:mm").replace(":", ""),
        endtime: moment(timeRange[1]._d).format("HH:mm").replace(":", ""),
        onetimeaction: frequency === "once" ? 0 : 1,
        transactiontopic: domainname + "/mqtt_" + username,
        siteid,
      })
        .then((res) => {
          if (res.error) {
            notification.error({
              message: "Failed",
              description: "Failed to complete command",
            });
            return;
          } else {
            //   console.log(res.data, "response");
            setresult(res.data);
            setopenresult(true);
            setcommand(intialCommand);
          }
        })
        .catch((res) => {
          errorBlock(res);
        });
    }
  };

  return (
    <Drawer
      className="relative"
      title="Schedule Connection"
      placement="right"
      onClose={() => setOpen(null)}
      open={open}
      width={400}
    >
      {type == "alias" ? (
        <p>
          Configure when meters in segmentation should be active. Select
          specific days of the week, set a time range, and choose how frequently
          it should repeat.
        </p>
      ) : (
        <p>
          Configure when meters in should be active on specific days of the
          week, set a time range, and choose how frequently it should repeat.
        </p>
      )}

      <Divider orientation="left" className="!text-[14px]">
        ⏰ Time
      </Divider>
      <div className="font-semibold">
        Time range <span className="text-[11px] font-light mb-2">(24hrs)</span>
      </div>
      <div className="mt-2">
        <TimePicker.RangePicker
          format={"HH:mm"}
          className="!w-full rounded-md"
          //   size="large"
          onChange={handleTimeChange}
        />
      </div>

      <Divider orientation="left" className="!text-[13px] !mt-10">
        📅 Active days
      </Divider>
      <div className="grid grid-cols-4 gap-4">
        {daysofWeek.map((day, index) => (
          <div
            key={index}
            onClick={() => handleDayClick(index)}
            className={`flex h-[80px] transition duration-200 cursor-pointer capitalize rounded-md shadow-sm flex-col items-center justify-center 
            ${
              day.id === 1
                ? "bg-blue-500 text-white"
                : "bg-blue-50 hover:bg-blue-500 hover:text-white"
            }`}
          >
            <div className="font-semibold text-[12px]">{day.short}</div>
          </div>
        ))}
      </div>

      <Divider orientation="left" className="!text-[13px] !mt-10">
        📅 Frequency
      </Divider>
      <h1 className="mt-4 font-semibold">
        How often should this command take place?
      </h1>
      <div className="flex mt-2 items-center justify-between">
        <p className="font-light">Repeat every week</p>
        <Switch
          checked={frequency === "weekly"}
          onChange={() => handleFrequencyChange("weekly")}
        />
      </div>
      <div className="flex items-center justify-between">
        <p className="font-light">Just once</p>
        <Switch
          checked={frequency === "once"}
          onChange={() => handleFrequencyChange("once")}
        />
      </div>

      <Button
        loading={isLoading || connectloading}
        type="primary"
        htmlType="button"
        className="mt-4 bottom-[-100px] w-full !bg-primary !border-none"
        onClick={handleSubmit}
      >
        Save Schedule
      </Button>
    </Drawer>
  );
};

export default ScheduleConnection;
